/*
 * Transforms the NC COA Purpose Code to the legacy value.
 * Legacy value is 4 characters.
 * New COA length for Purpose is 5 characters.
 * Existing Purpose Codes should have been converted from 4 characters
 * to 5 characters with the last character being zero.
 * 8100 => 81000
 */
window.transformPurposeToLegacyValue = function (purposeCode) {
	if (purposeCode && purposeCode.length > 4) {
		purposeCode = purposeCode.substring(0, 4);
	}
	return purposeCode;
};

/*
 * Transforms the NC COA Object Code to the legacy value.
 * Legacy value is 3 characters.
 * New COA length for Object is 5 characters.
 * Existing Purpose Codes should have been converted from 3 characters
 * to 5 characters with the a zero inserted into the 1st and last positions.
 * 321 => 03210
 */
window.transformObjectToLegacyValue = function (objectCode) {
	if (objectCode && objectCode.length === 5) {
		objectCode = objectCode.substring(1, objectCode.length - 1);
	}
	return objectCode;
};
